const STATIC_URL_PREFIX = "https://static.gamezop.com/pantheon/"
const URL_IMG_PREFIX = "assets/img/"

const IMG_STATIC_PREFIX_URL = STATIC_URL_PREFIX + URL_IMG_PREFIX

export const IMAGES = {
  IC_INFO: `${IMG_STATIC_PREFIX_URL}global-info-icon.svg`,
  GAMEZOP_LOGO: "https://static.gamezop.com/logo/gamezop-main-long-blue.png",
}
